jQuery(document).ready(function ($) {

    var module_name = 'top_bookmakers';
});